import React from "react";
import "./App.css";
import MainPage from "./MainPage";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./css/Style.css";
import "./css/Login.css";
import "./css/Sidebar.css";
import "./css/SearchHeader.css";
import "./css/Dashboard.css";
import "./css/CooperativeList.css";
import "./css/Complaints.css";
import "./css/Notices.css";
import "./css/Register.css";
import "./css/Loader.css";
import "./css/User.css";
import "./css/Settings.css"
import "./css/Admin.css"
import "./css/Document.css"
import "./css/Notification.css"
import { SidebarProvider } from "./context/SidebarContext";
import { LoaderProvider } from "./context/LoaderContext";
import { useToast } from "./hooks/useToast";
import { UserProvider } from "./context/UserContext";
import { OptionProvider } from "./context/OptionContext";
import { SettingsProvider } from "./context/SettingsContext";
import { RoleProvider } from "./context/RoleContext";

function App() {
  return (
    <>
      <UserProvider>
        <LoaderProvider>
          <OptionProvider>
            <RoleProvider>
              <SettingsProvider>
                <SidebarProvider>
                  <BrowserRouter>
                    <MainPage />
                  </BrowserRouter>
                </SidebarProvider>
              </SettingsProvider>
            </RoleProvider>
          </OptionProvider>
        </LoaderProvider>
      </UserProvider>
      {useToast()}
    </>
  );
}

export default App;
